import { useEffect } from 'react';
import '../assets/styles/Notification.css';

/**
 * Notification posée en haut à droite de l'écran, par-dessus la page.
 *
 * Pour ce qu'un clic dans un tableau ne peut pas expliquer sur place : une
 * génération de devis refusée par le service d'IA, par exemple. Le titre dit
 * ce qui n'a pas marché, le message dit pourquoi et quoi faire.
 *
 * `dureeMs` referme la notification d'elle-même (succès, information) ; sans
 * durée, elle reste jusqu'au clic sur « Fermer » — une erreur ne doit pas
 * disparaître avant d'avoir été lue.
 */
function Notification({ type = 'erreur', titre, message, onFermer, dureeMs = null }) {
  useEffect(() => {
    if (!dureeMs || !onFermer) return undefined;
    const minuteur = setTimeout(onFermer, dureeMs);
    return () => clearTimeout(minuteur);
  }, [dureeMs, onFermer, message]);

  return (
    <div className={`notif notif-${type}`} role={type === 'erreur' ? 'alert' : 'status'}>
      <div className="notif-icone" aria-hidden="true">
        {type === 'erreur' ? '!' : type === 'succes' ? '✓' : 'i'}
      </div>
      <div className="notif-corps">
        {titre && <div className="notif-titre">{titre}</div>}
        <div className="notif-message">{message}</div>
      </div>
      {onFermer && (
        <button type="button" className="notif-fermer" onClick={onFermer} aria-label="Fermer">
          ×
        </button>
      )}
    </div>
  );
}

export default Notification;
